import styled from 'styled-components';
import theme from 'styles/theme';
import ExclamationIcon from './ExclamationIcon.svg?react';

export const ExclamationIconStyled = styled(ExclamationIcon)`
  color: ${theme.colors.hostfullyOrange};
`;
